  document.addEventListener('click', function (e) {
    const accordion = e.target.closest('.footer-btn-tab .accordion');
    if (!accordion) return;

    const panel = accordion.nextElementSibling;
    if (!panel) return;

    accordion.classList.toggle('foot-view');
    panel.classList.toggle('foot-show');

    // border logic
    if (panel.classList.contains('foot-show')) {
      accordion.classList.add('hide-border-bottom');
    } else {
      accordion.classList.remove('hide-border-bottom');
    }
  });
